import { Col, Row } from 'react-bootstrap';
import { LinkButton } from 'shared/components';

export const CardAuthorizationsFooter = (props: {
  isAuthSearch: boolean;
  goBack(): void;
  goToAccountMovements(): void;
}) => {
  return (
    <Row>
      {props.isAuthSearch && (
        <Col className="text-center">
          <LinkButton onClick={props.goToAccountMovements}>
            Ver movimientos de la cuenta
          </LinkButton>
        </Col>
      )}
      <Col className="text-center">
        <LinkButton onClick={props.goBack}>Volver</LinkButton>
      </Col>
    </Row>
  );
};
